module.exports = __webpack_public_path__ + "img/service_5.05ea8e5e.png";